import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import cusHeader from '@/components/cus-header/cus-header' //主框架
Vue.config.productionTip = false
// 获取用户权限
let userinfo = localStorage.getItem("userinfo"),
	authority = '';
if (userinfo && userinfo !== "{}") {
	authority = JSON.parse(userinfo).rule
}
if (window.top !== window.self) {
	window.top.location = window.location;
}
Vue.prototype.authority = authority
Vue.use(ElementUI);
Vue.component('cus-header', cusHeader)
new Vue({
	router,
	render: h => h(App),
}).$mount('#app')